export default "__VITE_ASSET__C75r_iPi__"